<template>
  <div class="m-container">
    <div class="m-header">
      <div class="m-header-left">
        <a href="#" @click="toPage()" style="cursor: pointer;"><img src="../assets/img/logo4.png" alt=""/></a>
      </div>
      <div class="m-header-right">
<!--        <div><a href="#">登录</a></div>-->
<!--        <div style="margin-left: 10px"><a href="#">注册</a></div>-->
      </div>
    </div>
    <div class="m-content">
      <div class="m-content-opt"><span @click="toPage()" style="display: inline-block; cursor: pointer;">首页</span> > {{dataList[listIndex].title}}</div>
      <div style="display: flex">
        <div class="m-content-left">
          <div class="m-content-book-img">
            <img :src="dataList[listIndex].img" alt="">
            <div class="m-content-book-tip">热门书籍</div>
          </div>
          <div class="m-content-book-ot">
            <div class="m-content-book-ot-item"><i class="el-icon-share"></i><span>分享</span></div>
            <div class="m-content-book-ot-item"><i class="el-icon-circle-plus"></i><span>收藏</span></div>
          </div>
        </div>
        <div class="m-content-right" style="padding-left: 20px; box-sizing: border-box">
          <div class="m-content-book-tit">
            {{dataList[listIndex].title}}
          </div>
          <div class="m-content-book-ext">
            <div class="m-content-book-ext-item">上架时间：<span>2022年01月</span></div>
            <div class="m-content-book-ext-item">出版社：<span>中译出版社</span></div>
            <div class="m-content-book-ext-item">
              <i class="el-icon-circle-plus"></i>
              12条收藏
            </div>
          </div>
          <div class="m-content-book-money">
            价格：<span>￥{{dataList[listIndex].money}}</span>
          </div>
          <div class="m-content-book-num">
            数量：{{dataList[listIndex].number}}
          </div>
          <div class="m-content-cx">
            <div>促销：</div>
            <div class="m-content-cx-cont">
              <div class="m-content-cx-tip">
                加价折扣
              </div>
              <span>购买本商品可加价购买以下任意一件商品</span>
              <div class="m-content-cx-opt">
                <div class="m-content-cx-opt-item">
                  <div><img style="width: 70px;" :src="dataList[(listIndex+1) >= dataList.length ? 0: listIndex+1].img" alt=""></div>
                  <div style="margin: 10px 0 0 10px; display: flex;flex-wrap: wrap;">
                    <div style="width: 100%;">{{ dataList[(listIndex+1) >= dataList.length ? 0: listIndex+1].title }}</div>
                    <div style="width: 100%;font-size: 14px;">价格：<span style="color: #ff4141;">￥{{ dataList[(listIndex+1) >= dataList.length ? 0: listIndex+1].money }}</span></div>
                  </div>
                </div>
                <div class="m-content-cx-opt-item">
                  <div><img style="width: 70px;" :src="dataList[(listIndex+2) >= dataList.length ? 1: listIndex+2].img" alt=""></div>
                  <div style="margin: 10px 0 0 10px; display: flex;flex-wrap: wrap;">
                    <div style="width: 100%;">{{ dataList[(listIndex+2) >= dataList.length ? 1: listIndex+2].title }}</div>
                    <div style="width: 100%;font-size: 14px;">价格：<span style="color: #ff4141;">￥{{ dataList[(listIndex+2) >= dataList.length ? 1: listIndex+2].money }}</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="color: #666666;margin-top: 20px;font-size: 14px;">
            服务：都“画梦笔”发货，并提供售后服务，22:00前完成下单，预计4至7天送达
          </div>
          <div class="m-content-cx-buy" @click="openBuy">立即购买</div>
        </div>
      </div>
    </div>
    <div class="m-foot">
      <div class="m-foot-line"></div>
      <div style="margin: 20px 0 20px 0;">
        <p>北京画梦笔信息系统科学研究院有限公司</p>
        <p><a style="color: #666666" href="javascript:;">出版物经营许可证：新出发京零字第顺210027号</a></p>
        <p><a style="color: #666666" target="_black" href="http://beian.miit.gov.cn/#/Integrated/index" >增值电信业务经营许可证：京B2-20210760</a></p>
        <p><a style="color: #666666" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" class="baiA"> 京ICP备2021001946号-1</a></p>
        <div style="margin: 5px 0; display: flex;align-items: center;justify-content: center;">
          <div>
            <img style="width: 16px; height: 16px;display: inline-block;margin-right: 3px;" src="../assets/img/备案图标.png" alt="">
          </div>
          <div style="padding-bottom: 3px;">
            <a style="color: #666666" href="https://beian.mps.gov.cn/#/query/webSearch?code=11011302006882" rel="noreferrer" target="_blank">京公网安备11011302006882</a>
          </div>
        </div>
        <p>北京市顺义区金穗路2号院9号楼8层805</p>
      </div>
    </div>
    <el-dialog title="请输入收货地址" :visible.sync="openState" @close='closeDialog' width="650px" center>
      <div class="m-open-container">
        <div class="zs-open-body-ov" style="margin-right: 40px;">
          <el-form :model="form" :rules="rules" ref="form" label-width="110px">
            <el-form-item label="姓名: " prop="name">
              <el-input v-model="form.name" placeholder="输入您的姓名"></el-input>
            </el-form-item>
            <el-form-item label="电话: " prop="phone">
              <el-input v-model="form.phone" placeholder="输入您的电话"></el-input>
            </el-form-item>
            <el-form-item label="所在地区: " prop="selectedOptions">
              <div>
                <el-cascader
                  size="large"
                  :options="options"
                  v-model="selectedOptions"
                  @change="handleChange"
                >
                </el-cascader>
              </div>
            </el-form-item>
            <el-form-item label="详细地址: " prop="address">
              <el-input v-model="form.address" placeholder="输入您的详细地址"></el-input>
            </el-form-item>
            <el-form-item label="标签: " prop="agreementType">
              <el-checkbox-group v-model="checkList">
                <el-checkbox label="家"></el-checkbox>
                <el-checkbox label="公司"></el-checkbox>
                <el-checkbox label="学校"></el-checkbox>
                <el-checkbox label="其他"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="设为默认地址: " prop="agreementType">
              <el-switch
                v-model="switchValue">
              </el-switch>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button @click="openState = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="请扫码支付" :visible.sync="openBuyState" @close='closeDialog' width="650px" center>
      <div class="m-open-container" style="margin-bottom: 40px;">
        <div style="text-align: center;">
          画梦笔订单 <span>收款方：北京画梦笔信息系统科学研究院有限公司</span>
        </div>
        <div class="m-open-buy-opt">
          <div @click="selectBuyType(0)" class="m-open-buy-opt-item" :class="buyType === 0 ? 'm-open-buy-opt-at' : ''">
            <img src="../assets/img/zhifubao.gif" alt="">
            <div v-if="buyType === 0" class="m-open-buy-opt-at-tip"><i class="el-icon-s-finance"></i></div>
          </div>
          <div @click="selectBuyType(1)" class="m-open-buy-opt-item" :class="buyType === 1 ? 'm-open-buy-opt-at' : ''">
            <img src="../assets/img/weixin.gif" alt="">
            <div v-if="buyType === 1" class="m-open-buy-opt-at-tip"><i class="el-icon-s-finance"></i></div>
          </div>
        </div>
        <div class="m-open-buy-code">
          <img v-if="buyType === 0 && buyLoading === false" src="../assets/img/zfb.jpg" alt="">
          <img v-if="buyType === 1 && buyLoading === false" src="../assets/img/weixin.jpg" alt="">
          <div v-if="buyLoading" class="m-open-buy-code-load" v-loading="buyLoading"></div>
        </div>
        <div style="text-align: center;margin-top: 20px;">
          <i class="el-icon-full-screen"></i>
          打开手机扫描二维码支付
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { regionData, CodeToText } from 'element-china-area-data'
export default {
  name: 'subclass',
  data () {
    return {
      options: regionData,
      selectedOptions: [],
      listIndex: 0,
      buyType: 0,
      openState: false,
      openBuyState: false,
      switchValue: false,
      buyLoading: false,
      form: {
        name: '',
        city: '',
        address: '',
        phone: ''
      },
      checkList: [],
      dataList: [
        {id: '1', img: require('../assets/img/book1.jpg'), title: '授权', number: 99, money: 44.2},
        {id: '2', img: require('../assets/img/book2.jpg'), title: '教养在生活的细节里', number: 99, money: 39.9},
        {id: '3', img: require('../assets/img/book3.jpg'), title: '稻盛和夫语录100条', number: 99, money: 39},
        {id: '4', img: require('../assets/img/book4.jpg'), title: '传习录', number: 99, money: 32},
        {id: '5', img: require('../assets/img/book5.jpg'), title: '贫穷的本质', number: 99, money: 58},
        {id: '6', img: require('../assets/img/book6.jpg'), title: '创业从0到1', number: 99, money: 48},
        {id: '7', img: require('../assets/img/book7.jpg'), title: '细节', number: 99, money: 36.2},
        {id: '8', img: require('../assets/img/book8.jpg'), title: '内藤湖南的中国学', number: 99, money: 68},
        {id: '9', img: require('../assets/img/book9.jpg'), title: '你的格局决定你的结局', number: 99, money: 32},
        {id: '10', img: require('../assets/img/book10.jpg'), title: '华为高效工作法', number: 99, money: 34},
        {id: '11', img: require('../assets/img/book11.jpg'), title: '简单的力量', number: 99, money: 59},
        {id: '12', img: require('../assets/img/book12.jpg'), title: '组织革新', number: 99, money: 68},
        {id: '13', img: require('../assets/img/book13.jpg'), title: '碳金融市场的定价与价格运行机制研究', number: 99, money: 35.3},
        {id: '14', img: require('../assets/img/book14.jpg'), title: '零碳社会', number: 99, money: 69},
        {id: '15', img: require('../assets/img/book15.jpg'), title: '夜航船', number: 99, money: 59.8},
        {id: '16', img: require('../assets/img/book16.jpg'), title: '创业第一年要考虑的16件事', number: 99, money: 39.8},
        {id: '17', img: require('../assets/img/book17.jpg'), title: '大卖', number: 99, money: 42},
        {id: '18', img: require('../assets/img/book18.jpg'), title: '懂心理学的妈妈都很了不起', number: 99, money: 59.8}
      ],
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        city: [
          { required: true, message: '请选择所属地区', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    let id = this.$route.params.id
    for (let i = 0; i < this.dataList.length; i++) {
      if (this.dataList[i].id === id) {
        this.listIndex = i
      }
    }
  },
  methods: {
    selectBuyType (type) {
      this.buyLoading = true
      this.buyType = type
      setTimeout(() => {
        this.buyLoading = false
      }, 1500)
    },
    handleChange () {
      let loc = ''
      for (let i = 0; i < this.selectedOptions.length; i++) {
        loc += CodeToText[this.selectedOptions[i]]
      }
      // alert(loc)
      this.city = loc
    },
    closeDialog () {
    },
    submit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.openState = false
          this.openBuyState = true
          this.buyLoading = true
          setTimeout(() => {
            this.buyLoading = false
          }, 1500)
        } else {
          return false
        }
      })
    },
    openBuy () {
      this.openState = true
    },
    toPage () {
      this.$router.push({
        name: 'home'
      })
    }
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Subclass.vue